import { isPresent } from '../utils/typescript';
import { Url } from './common';

export interface PersonLike<ID> {
  id: ID;
  fullName: string;
  avatar: Url | null;
}

export default class Person<ID> implements PersonLike<ID> {
  id!: ID;
  firstName = '';
  lastName = '';
  avatar: Url | null = null;

  private _fullName = '';
  private _initials = '';

  get hasId(): boolean {
    return isPresent(this.id);
  }

  set fullName(value: string) {
    this._fullName = value;
  }

  get fullName(): string {
    return this._fullName || [this.firstName, this.lastName].filter(Boolean).join(' ');
  }

  set initials(value: string) {
    this._initials = value;
  }

  get initials(): string {
    return this._initials || [this.firstName, this.lastName].filter(Boolean).map(n => n[0]).join('');
  }
}
